import { solePublisherGameId } from "@seabrookstudios/pitch2table-core";

/**
 * @param {import("@seabrookstudios/pitch2table-core").InboxMatchCandidate} candidate
 * @returns {number}
 */
export const candidateScore = (candidate) => {
  return candidate.score ?? 0;
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").InboxMatchCandidate[]|null|undefined} candidates
 * @param {{ id: import("@seabrookstudios/pitch2table-core").PublisherGameId }[]|null|undefined} publishers
 * @returns {import("@seabrookstudios/pitch2table-core").PublisherGameId|null}
 */
export const highestScoringCandidatePublisherGameId = (candidates, publishers) => {
  if (!candidates?.length || !publishers?.length) {
    return null;
  }

  const publisherIds = new Set(
    publishers.map((publisher) => {
      return publisher.id;
    })
  );
  const matching = [...candidates]
    .filter((candidate) => {
      return candidate.publisherGameId && publisherIds.has(candidate.publisherGameId);
    })
    .sort((a, b) => {
      return candidateScore(b) - candidateScore(a);
    });

  return matching[0]?.publisherGameId || null;
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").InboxMatchCandidate[]|null|undefined} candidates
 * @param {{ id: import("@seabrookstudios/pitch2table-core").PublisherGameId }[]|null|undefined} publishers
 * @param {{ allowSolePublisherFallback?: boolean }} [options]
 * @returns {import("@seabrookstudios/pitch2table-core").PublisherGameId|null}
 */
export const defaultPublisherGameIdForPickedGame = (
  candidates,
  publishers,
  { allowSolePublisherFallback = false } = {}
) => {
  const fromCandidates = highestScoringCandidatePublisherGameId(candidates, publishers);
  if (fromCandidates) {
    return fromCandidates;
  }
  if (allowSolePublisherFallback) {
    return solePublisherGameId(publishers);
  }
  return null;
};

/**
 * @param {import("@seabrookstudios/types").GameId|null|undefined} gameId
 * @param {import("@seabrookstudios/pitch2table-core").PublisherGameId|null|undefined} publisherGameId
 * @param {boolean} publishersReady
 * @param {import("@seabrookstudios/types").GameId|null|undefined} defaultedForGameId
 * @returns {boolean}
 */
export const shouldApplyPublisherDefault = (
  gameId,
  publisherGameId,
  publishersReady,
  defaultedForGameId
) => {
  return Boolean(
    gameId && !publisherGameId && publishersReady && defaultedForGameId !== gameId
  );
};

/**
 * Value written to defaultedForGameIdRef when Change publisher clears the selection.
 * Deleting this stamp reintroduces the auto-default no-op bug.
 *
 * @param {import("@seabrookstudios/types").GameId|null|undefined} gameId
 * @returns {import("@seabrookstudios/types").GameId|null}
 */
export const stampAfterChangePublisher = (gameId) => {
  return gameId || null;
};
